import { get, writable } from "svelte/store"
import { baseURL } from "./configs/config"
import { _fetch } from "./api"

function getInitialLang() {
    const path = (typeof window !== "undefined" && window.location?.pathname) || "/"
    if (path.startsWith("/en")) return "en"
    return "de"
}

const initLoc = {
    path: (typeof window !== "undefined" && window.location?.pathname) || "/",
    search: (typeof window !== "undefined" && window.location?.search) || "",
    hash: (typeof window !== "undefined" && window.location?.hash) || "",
    push: false,
    pop: false,
    categoryPath: "",
    url: `${baseURL}${(typeof window !== "undefined" && window.location?.pathname) || "/"}`,
}
initLoc.categoryPath = initLoc.path.replace(/\/\d{4,99}[^\/]+$/, "")
export const location = writable<LocationStore>(initLoc)
export const apiBaseOverride = writable<string | null>(null)
export const isHeroVisible = writable(false)
export const lang = writable(getInitialLang())
export const languageSwitching = writable(false)
export const currentPage = writable<{
    id: string
    url: string
    no_en_version?: boolean
} | null>(null)
export const topics = writable<{
    [slug: string]: Topic
}>({})
export const eventseries = writable<{
    [slug: string]: EventSeries
}>({})
export const eventlocations = writable<{
    [slug: string]: EventLocation
}>({})
export const topicsLoaded = writable(false)

export function getTopicById(id: string) {
    return Object.values(get(topics)).filter((topic: Topic) => id.includes(topic.uuid))
}

export function getEventSeriesById(id: string) {
    return Object.values(get(eventseries)).find((series) => id.includes(series.uuid))
}

export function getEventLocationById(id: string) {
    return Object.values(get(eventlocations)).find((eventLocation) => id.includes(eventLocation.uuid))
}

export const subNavs = writable<[string[], NavSectionContent][]>([])

export const overlay = writable<SidebarOverlay>({
    show: false,
    type: "search",
    properties: {},
})
